// import React, { useMemo } from "react";
// import dayjs from "dayjs";
// import { SUBJECT_THEMES, STATUS_COLORS } from "../data/mockData";

// const CalendarGrid = ({ events, currentDate, onEventClick }) => {
//   const hours = Array.from({ length: 14 }, (_, i) => 7 + i); // Từ 7:00 đến 20:00
//   const startOfWeek = currentDate.startOf("week").add(1, "day");
//   const days = Array.from({ length: 7 }, (_, i) => startOfWeek.add(i, "day"));

//   // Nhóm sự kiện theo ngày và giờ bắt đầu để xử lý trùng lịch (overlap)
//   const groupedEvents = useMemo(() => {
//     const map = {};
//     events.forEach((ev) => {
//       const key = `${ev.day}-${ev.start}`;
//       if (!map[key]) map[key] = [];
//       map[key].push(ev);
//     });
//     return map;
//   }, [events]);

//   return (
//     <div className="flex flex-col h-full bg-white overflow-x-auto">
//       {/* Header: Các thứ trong tuần */}
//       <div className="grid grid-cols-[80px_repeat(7,1fr)] border-b bg-slate-50 sticky top-0 z-10">
//         <div className="p-4 border-r"></div>
//         {days.map((d, i) => (
//           <div key={i} className={`p-3 text-center border-r last:border-0 ${d.isSame(dayjs(), 'day') ? 'bg-red-50' : ''}`}>
//             <p className="text-xs font-semibold text-slate-500 uppercase">{d.format("ddd")}</p>
//             <p className={`text-lg font-bold ${d.isSame(dayjs(), 'day') ? 'text-red-600' : 'text-slate-700'}`}>
//               {d.format("DD/MM")}
//             </p>
//           </div>
//         ))}
//       </div>

//       {/* Body: Lưới giờ */}
//       <div className="grid grid-cols-[80px_repeat(7,1fr)] flex-grow overflow-y-auto min-h-[800px]">
//         {/* Cột hiển thị giờ */}
//         <div className="border-r bg-slate-50/50">
//           {hours.map((h) => (
//             <div key={h} className="h-20 border-b text-center text-xs font-medium text-slate-400 pt-2">
//               {h}:00
//             </div>
//           ))}
//         </div>

//         {/* Các cột nội dung ngày */}
//         {days.map((_, dayIdx) => (
//           <div key={dayIdx} className="relative border-r last:border-0 bg-white">
//             {hours.map((h) => (
//               <div key={h} className="h-20 border-b border-slate-100"></div>
//             ))}

//             {/* Render các lớp học */}
//             {events
//               .filter((ev) => ev.day === dayIdx + 1)
//               .map((ev) => {
//                 const theme = SUBJECT_THEMES[ev.subject] || SUBJECT_THEMES.default;
//                 const top = (ev.start - 7) * 80; // Mỗi tiếng cao 80px, bắt đầu từ 7h
//                 const height = (ev.end - ev.start) * 80;

//                 return (
//                   <div
//                     key={ev.id}
//                     onClick={() => onEventClick(ev)}
//                     className={`absolute inset-x-1 mx-1 p-2 rounded-lg border-l-4 shadow-sm cursor-pointer transition-all hover:scale-[1.02] hover:z-20 ${theme.bg} ${theme.border} ${theme.text}`}
//                     style={{ top: `${top}px`, height: `${height - 4}px` }}
//                   >
//                     <div className="flex justify-between items-start mb-1">
//                       <span className="text-[10px] font-bold uppercase tracking-wider opacity-70">
//                         {ev.branch.split("-")[0]}
//                       </span>
//                       <span className={`text-[9px] px-1.5 py-0.5 rounded-full border font-bold ${STATUS_COLORS[ev.status].color}`}>
//                         {STATUS_COLORS[ev.status].label}
//                       </span>
//                     </div>
//                     <p className="font-bold text-sm leading-tight truncate">{ev.class}</p>
//                     <p className="text-[11px] font-medium mt-1 truncate">👤 {ev.teacher}</p>
//                     <div className="absolute bottom-1 right-2 opacity-60 text-[10px] font-bold">
//                       {ev.room}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CalendarGrid;










import React, { useMemo } from "react";
import dayjs from "../../../../utils/dayjs";
import { STATUS_COLORS } from "../data/mockData";
import { getSubjectTheme, formatScheduleEventHint } from "../subjectThemeUtils";

const CalendarGrid = ({ events, currentDate, onEventClick }) => {
  const hours = Array.from({ length: 14 }, (_, i) => 7 + i); // Từ 7:00 đến 20:00

  // SỬA TẠI ĐÂY: Sử dụng isoWeek để bắt đầu từ Thứ 2
  const startOfWeek = useMemo(() => currentDate.startOf("isoWeek"), [currentDate]);
  
  // Tạo mảng 7 ngày bắt đầu từ Thứ 2
  const days = useMemo(() => 
    Array.from({ length: 7 }, (_, i) => startOfWeek.add(i, "day")),
  [startOfWeek]);

  // Nhóm sự kiện theo ngày và giờ bắt đầu
  const groupedEvents = useMemo(() => {
    const map = {};
    events.forEach((ev) => {
      const key = `${ev.day}-${ev.start}`;
      if (!map[key]) map[key] = [];
      map[key].push(ev);
    });
    return map;
  }, [events]);

  return (
    <div className="flex flex-col h-full bg-white overflow-x-auto">
      {/* Header: Các thứ trong tuần */}
      <div className="grid grid-cols-[80px_repeat(7,1fr)] border-b bg-slate-50 sticky top-0 z-10">
        <div className="p-4 border-r"></div>
        {days.map((d, i) => {
          const isToday = d.isSame(dayjs(), 'day');
          return (
            <div key={i} className={`p-3 text-center border-r last:border-0 ${isToday ? 'bg-red-50' : ''}`}>
              <p className={`text-xs font-semibold uppercase ${isToday ? 'text-red-500' : 'text-slate-500'}`}>
                {d.format("ddd")}
              </p>
              <p className={`text-lg font-bold ${isToday ? 'text-red-600' : 'text-slate-700'}`}>
                {d.format("DD/MM")}
              </p>
            </div>
          );
        })}
      </div>

      {/* Body: Lưới giờ */}
      <div className="grid grid-cols-[80px_repeat(7,1fr)] flex-grow overflow-y-auto min-h-[800px]">
        {/* Cột hiển thị giờ */}
        <div className="border-r bg-slate-50/50">
          {hours.map((h) => (
            <div key={h} className="h-20 border-b text-center text-xs font-medium text-slate-400 pt-2">
              {h}:00
            </div>
          ))}
        </div>

        {/* Các cột nội dung ngày */}
        {days.map((_, dayIdx) => (
          <div key={dayIdx} className="relative border-r last:border-0 bg-white">
            {hours.map((h) => (
              <div key={h} className="h-20 border-b border-slate-100"></div>
            ))}

            {/* Render các lớp học */}
            {events
              .filter((ev) => ev.day === dayIdx + 1) // dayIdx 0 = Thứ 2 (khớp với mockData day: 1)
              .map((ev) => {
                const theme = getSubjectTheme(ev);
                const top = (ev.start - 7) * 80;
                const height = (ev.end - ev.start) * 80;

                return (
                  <div
                    key={ev.id}
                    onClick={() => onEventClick(ev, days[dayIdx])}
                    title={formatScheduleEventHint(ev)}
                    className={`absolute inset-x-1 mx-1 p-2 rounded-lg border-l-4 shadow-sm cursor-pointer transition-all hover:scale-[1.02] hover:z-20 ${theme.bg} ${theme.border} ${theme.text}`}
                    style={{ top: `${top}px`, height: `${height - 4}px`, borderLeftColor: theme.accent }}
                  >
                    <div className="flex justify-between items-start mb-1">
                      <span className="text-[10px] font-bold uppercase tracking-wider opacity-70">
                        {ev.branch.split("-")[0]}
                      </span>
                      <span className={`text-[9px] px-1.5 py-0.5 rounded-full border font-bold ${STATUS_COLORS[ev.status].color}`}>
                        {STATUS_COLORS[ev.status].label}
                      </span>
                    </div>
                    <div className="mt-1 space-y-1.5">
                      <div className="inline-flex items-center gap-2 max-w-full">
                        <span className="px-2 py-0.5 rounded-md bg-white/60 border border-white/40 text-[11px] font-extrabold text-gray-800 truncate">
                          {ev.class}
                        </span>
                        {ev.subject ? (
                          <span
                            className={`px-2 py-0.5 rounded-md border text-[9px] font-bold ${theme.text} ${theme.border} bg-white/40 truncate`}
                            title={ev.subject}
                          >
                            {ev.subject}
                          </span>
                        ) : null}
                      </div>
                      <p className="text-[10.5px] font-semibold text-gray-700 truncate">
                        👤 {ev.teacher}
                      </p>
                      <p className="text-[10px] font-medium text-gray-500 truncate">
                        {ev.venue === "school" ? "Tại trường" : "Trung tâm"} · {ev.room}
                      </p>
                    </div>
                  </div>
                );
              })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalendarGrid;